import React, { useContext, useState } from "react";
import backgroundProvider from "../../../assets/img/backgroundProvider.png";
import ShowImage from "../../../components/common/ShowImage";
import UserContext from "../../../context/user-context";
import useShowImage from "../../../hooks/useShowImage";
import { useTranslation } from "../../../hooks/useTranslation";
import useUploadImage from "../../../hooks/useUploadImage";
import { fileNames } from "../../../utils/imageUtil";

const Bicycle = () => {
  const { t, BundleKey } = useTranslation();
  const { state } = useContext(UserContext);
  const getImage = useShowImage();
  const [bicyclePhoto, setBicyclePhoto] = useState<any>(
    getImage(state.bicyclePhoto)
  );
  const { uploadNewPhoto } = useUploadImage();

  const uploadNewBicyclePhoto = (newPhoto: any) => {
    setBicyclePhoto(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "bicyclePhoto",
      fileNames.EVENT_BICYCLE_PHOTO_FILENAME
    );
  };
  return (
    <>
      <ShowImage
        title={t(BundleKey.DETAIL_ENTRYMETHOD_BICYCLE_PHOTO)}
        defaultImage={backgroundProvider}
        image={bicyclePhoto}
        uploadNewPhoto={uploadNewBicyclePhoto}
        alt={"photoBicycle"}
      />
    </>
  );
};

export default Bicycle;
